import React from "react";
import get from "lodash/get";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../constants";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";
import SubHeadline from "../../atoms/SubHeadline";

import "./games.m.css";

export const GameCard = ({
  story,
  showThumbnail,
  showReadTime,
  showTimestamp,
  showBorder,
  defaultFallback,
  buttonText,
  showCta,
  showSubheadline,
  sectionSlug,
}) => {
  const sponsor = get(story, ["metadata", "sponsored-by"], null);
  const isPartneredContent = story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor !== null;
  const imageUrl =
    get(story, ["hero-image-s3-key"], "") ||
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], "");
  const showImageThumbnail = (showThumbnail || (showCta && isPartneredContent)) && (imageUrl || defaultFallback);
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  const headlineStyleName = showImageThumbnail ? "show-thumbnail" : "hide-thumbnail"; // Full width if no image
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <div styleName="common-story" style={{ border: showBorder || "none" }} key={story.id}>
      <Link href={href} target={target}>
        <div styleName="second-card">
          <div styleName={`left-column ${headlineStyleName}`}>
            {label && <Label story={story} />}

            {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}

            {showSubheadline && story?.subheadline && (
              <SubHeadline styleName="subheadline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
            )}
            <PublishAndReadTime showReadTime={showReadTime} showTimestamp={showTimestamp} story={story} />
            {showCta && buttonText && <div styleName="cta-button">{buttonText}</div>}
          </div>
          {showImageThumbnail && (
            <div styleName="hero-image">
              <HeroImage
                story={story}
                headline={headline}
                aspectRatio={[[1, 1]]}
                iconSizes={{ height: 24, width: 24 }}
                imageUrl={imageUrl}
              />
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};

GameCard.propTypes = {
  story: object,
  showThumbnail: bool,
  showBorder: bool,
  showReadTime: bool,
  showTimestamp: bool,
  defaultFallback: bool,
  showSubheadline: bool,
  showCta: bool,
  buttonText: string,
  sectionSlug: string,
};
